/**
 * 重复东西很多，有怪莫怪，要怪就怪工期太短
 */

export default {
  data() {
    return {
      alarmChart: null, // 告警图
      roomStatChart: null, // 房源统计图
      auditRoomChart: null, // 审核房源信息图
      stayInTrendChart: null, // 在住趋势图
      managerStatChart: null, // 经营者统计图
      auditManagerChart: null, // 审核经营者信息图
      checkInTrendChart: null, // 入住趋势图
      chartPropNameList: [
        'alarmChart',
        'roomStatChart',
        'auditRoomChart',
        'stayInTrendChart',
        'managerStatChart',
        'auditManagerChart',
        'checkInTrendChart'
      ]
    }
  },
  directives: {
    resize: {
      mounted(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = ''
        let height = ''
        function isResize() {
          const style = document.defaultView.getComputedStyle(el)
          if (width !== style.width || height !== style.height) {
            binding.value && binding.value() // 关键
          }
          width = style.width
          height = style.height
        }
        el.__vueSetInterval__ = setInterval(isResize, 300)
      },
      unmounted(el) {
        clearInterval(el.__vueSetInterval__)
      }
    }
  },
  mounted() {
    // 初始化统计图
    setTimeout(() => {
      this.initCenterMap()
    }, 50)
  },
  methods: {
    // 初始化地图
    initCenterMap() {
      let point = {
        lng: 113.946069,
        lat: 22.550606
      }

      let map = new BMap.Map('center-map-container', { enableMapClick: false })
      let poi = new BMap.Point(point.lng, point.lat)
      map.centerAndZoom(poi, 16)
      map.enableScrollWheelZoom(true)

      map.addEventListener('click', (e) => {
        this.selectedRoomList = []
      })
      this.centerMap = map
    },
    // 处理大小变更事件
    handleResize() {
      clearTimeout(this.resizeTimer)

      // 重置统计图大小
      this.resizeTimer = setTimeout(() => {
        this.alarmChart && this.alarmChart.resize()
        this.roomStatChart && this.roomStatChart.resize()
        this.auditRoomChart && this.auditRoomChart.resize()
        this.stayInTrendChart && this.stayInTrendChart.resize()
        this.managerStatChart && this.managerStatChart.resize()
        this.auditManagerChart && this.auditManagerChart.resize()
        this.checkInTrendChart && this.checkInTrendChart.resize()

        setTimeout(() => {
          this.resetLineChartDefaultTip()
        }, 200)
      }, 50)
    },
    // 重新设置折线图的默认提示，防止页面大小变化后导致的不显示问题
    resetLineChartDefaultTip() {
      if (!this.isInitChartLine) {
        this.isInitChartLine = true
        return
      }

      this.initCheckInTrendChart()
      this.initStayInTrendChart()
      this.initAlarmChart()
    },
    // 处理统计chart大小变化
    handleResizeChartStat(chartProp) {
      let fn = () => {
        clearTimeout(this.resizeTimer)
        // 重置统计图大小
        this.resizeTimer = setTimeout(() => {
          this[chartProp] && this[chartProp].resize()
        }, 50)
      }

      return fn
    },
    // 同步到同比数据显示
    syncCompareData({ nowData, oldData, type }) {
      let trend = nowData == oldData ? 0 : nowData > oldData ? 1 : -1 // 趋势 1：增长，0：持平，-1：下降
      let trendPercent = 0
      if (oldData == 0) {
        trendPercent = '--%'
      } else {
        trendPercent = (((nowData - oldData) / oldData) * 100).toFixed(2) + '%'
      }

      switch (type) {
        case 'alarm':
          this.alarmTrend = { show: true, trend, value: nowData, trendPercent }
          break
        case 'stayIn':
          this.stayInTrend = { show: true, trend, value: nowData, trendPercent }
          break
        case 'checkIn':
          this.checkInTrend = { show: true, trend, value: nowData, trendPercent }
          break
      }
    },
    // echarts图点位显示防抖
    delayChartDispatch(chartProp, opts) {
      clearTimeout(this[chartProp + 'Timer'])

      this[chartProp + 'Timer'] = setTimeout(() => {
        if (!this[chartProp] || !this[chartProp].dispatchAction) return

        this[chartProp].dispatchAction(opts)
      }, opts.delayTime || 100)
    },
    // 初始化入住趋势图
    initCheckInTrendChart() {
      let _this = this

      let chartEl = document.getElementById('check-in-trend-chart')
      let chart = this.$echarts.init(chartEl)

      let xAxisData = ['', ...this.checkInStatData.map(item => item.date), '']
      let chartData = this.checkInStatData.map(item => item.value)
      let chartDataLen = chartData.length

      let option = {
        grid: {
          top: '65px',
          left: '-5px',
          right: '-5px',
          bottom: '40px'
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let data = params[0]
            if (data.dataIndex === 0 || data.dataIndex === chartDataLen + 1) {
              _this.checkInTrend = { show: false }
              return
            }

            if (data.dataIndex === 1) {
              _this.syncCompareData({ nowData: data.value, oldData: 0, type: 'checkIn' })
              this.curFocusCheckInIndex = data.dataIndex
            } else if (data.dataIndex > 1) {
              _this.syncCompareData({ nowData: data.value, oldData: chartData[data.dataIndex - 2], type: 'checkIn' })
              this.curFocusCheckInIndex = data.dataIndex
            } else {
              _this.checkInTrend = { show: false }
            }
            return `时间：${data.axisValueLabel}<br/>入住人数：${data.value}`
          },
          axisPointer: {
            z: 1, // 竖线在圆圈后面
            label: {
              backgroundColor: 'rgb(0, 0, 0)',
              color: 'red'
            }
          },
          confine: true // 浮窗不超出屏幕范围
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { rotate: 30 }
        },
        yAxis: {
          show: false
        },
        series: [
          {
            data: [chartData[0], ...chartData, chartData[chartDataLen - 1]],
            type: 'line',
            smooth: true,
            symbolSize: 1, // 折线点大小
            itemStyle: {
              color: 'rgb(68, 156, 215)'
            },
            lineStyle: {
              color: 'rgb(68, 156, 215)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(68, 156, 215, 1)' },
                { offset: 0.5, color: 'rgba(68, 156, 215, 0.5)' },
                { offset: 1, color: 'rgba(68, 156, 215, 0)' }
              ])
            }
          }
        ]
      }

      chart.setOption(option)
      // 这里getZr是指触发的整个折线图的事件，由于原本的事件只在小圆点上触发，极其反人类，所以这是折中方案
      chart.getZr().on('mouseout', () => {
        this.delayChartDispatch('checkInTrendChart', {
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.curFocusCheckInIndex
        })
      })

      if (!this.curFocusCheckInIndex || this.curFocusCheckInIndex > chartDataLen) {
        this.curFocusCheckInIndex = chartDataLen
      }
      this.delayChartDispatch('checkInTrendChart', {
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: this.curFocusCheckInIndex,
        delayTime: 200
      })

      this.checkInTrendChart = chart
    },
    // 初始化在住趋势图
    initStayInTrendChart() {
      let _this = this

      let chartEl = document.getElementById('stay-in-trend-chart')
      let chart = this.$echarts.init(chartEl)

      let xAxisData = ['', ...this.stayInStatData.map(item => item.date), '']
      let chartData = this.stayInStatData.map(item => item.value)
      let chartDataLen = chartData.length

      let option = {
        grid: {
          top: '65px',
          left: '-5px',
          right: '-5px',
          bottom: '40px'
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let data = params[0]
            if (data.dataIndex === 0 || data.dataIndex === chartDataLen + 1) {
              _this.stayInTrend = { show: false }
              return
            }

            if (data.dataIndex === 1) {
              _this.syncCompareData({ nowData: data.value, oldData: 0, type: 'stayIn' })
              this.curFocusStayInIndex = data.dataIndex
            } else if (data.dataIndex > 1) {
              _this.syncCompareData({ nowData: data.value, oldData: chartData[data.dataIndex - 2], type: 'stayIn' })
              this.curFocusStayInIndex = data.dataIndex
            } else {
              _this.stayInTrend = { show: false }
            }
            return `时间：${data.axisValueLabel}<br/>在住人数：${data.value}`
          },
          axisPointer: {
            z: 1, // 竖线在圆圈后面
            label: {
              backgroundColor: 'rgb(0, 0, 0)',
              color: 'red'
            }
          },
          confine: true // 浮窗不超出屏幕范围
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { rotate: 30 }
        },
        yAxis: {
          show: false
        },
        series: [
          {
            data: [chartData[0], ...chartData, chartData[chartDataLen - 1]],
            type: 'line',
            symbolSize: 1,
            smooth: true,
            itemStyle: {
              color: 'rgb(152, 35, 201)'
            },
            lineStyle: {
              color: 'rgb(152, 35, 201)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(152, 35, 201, 1)' },
                { offset: 0.5, color: 'rgba(152, 35, 201, 0.5)' },
                { offset: 1, color: 'rgba(152, 35, 201, 0)' }
              ])
            }
          }
        ]
      }

      chart.setOption(option)
      // 这里getZr是指触发的整个折线图的事件，由于原本的事件只在小圆点上触发，极其反人类，所以这是折中方案
      chart.getZr().on('mouseout', () => {
        this.delayChartDispatch('stayInTrendChart', {
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.curFocusStayInIndex
        })
      })

      if (!this.curFocusStayInIndex || this.curFocusStayInIndex > chartDataLen) {
        this.curFocusStayInIndex = chartDataLen
      }
      this.delayChartDispatch('stayInTrendChart', {
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: this.curFocusStayInIndex,
        delayTime: 200
      })

      this.stayInTrendChart = chart
    },
    // 初始化告警图
    initAlarmChart() {
      let _this = this

      let chartEl = document.getElementById('alarm-chart')
      let chart = this.$echarts.init(chartEl)

      let xAxisData = ['', ...this.alarmStatData.map(item => item.date), '']
      let chartData = this.alarmStatData.map(item => item.value)
      let chartDataLen = chartData.length

      let option = {
        grid: {
          top: '65px',
          left: '-5px',
          right: '-5px',
          bottom: '40px'
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let data = params[0]
            if (data.dataIndex === 0 || data.dataIndex === chartDataLen + 1) {
              _this.alarmTrend = { show: false }
              return
            }

            if (data.dataIndex === 1) {
              _this.syncCompareData({ nowData: data.value, oldData: 0, type: 'alarm' })
              this.curFocusAlarmIndex = data.dataIndex
            } else if (data.dataIndex > 1) {
              _this.syncCompareData({ nowData: data.value, oldData: chartData[data.dataIndex - 2], type: 'alarm' })
              this.curFocusAlarmIndex = data.dataIndex
            } else {
              _this.alarmTrend = { show: false }
            }
            return `时间：${data.axisValueLabel}<br/>告警数量：${data.value}`
          },
          axisPointer: {
            z: 1, // 竖线在圆圈后面
            label: {
              backgroundColor: 'rgb(0, 0, 0)',
              color: 'red'
            }
          },
          confine: true // 浮窗不超出屏幕范围
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { rotate: 30 }
        },
        yAxis: {
          show: false
        },
        series: [
          {
            data: [chartData[0], ...chartData, chartData[chartDataLen - 1]],
            type: 'line',
            symbolSize: 1,
            smooth: true,
            itemStyle: {
              color: 'rgba(255, 127, 74, 1)'
            },
            lineStyle: {
              color: 'rgba(255, 127, 74, 1)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 127, 74, 1)' },
                { offset: 0.5, color: 'rgba(255, 127, 74, 0.5)' },
                { offset: 1, color: 'rgba(255, 127, 74, 0)' }
              ])
            }
          }
        ]
      }

      chart.setOption(option)
      // 这里getZr是指触发的整个折线图的事件，由于原本的事件只在小圆点上触发，极其反人类，所以这是折中方案
      chart.getZr().on('mouseout', () => {
        this.delayChartDispatch('alarmChart', { type: 'showTip', seriesIndex: 0, dataIndex: this.curFocusAlarmIndex })
      })

      if (!this.curFocusAlarmIndex || this.curFocusAlarmIndex > chartDataLen) {
        this.curFocusAlarmIndex = chartDataLen
      }
      this.delayChartDispatch('alarmChart', {
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: this.curFocusAlarmIndex,
        delayTime: 200
      })

      this.alarmChart = chart
    },
    // 初始化审核信息图，查询接口是同一个，而且有很多重复的逻辑，所以先放在了同一个方法
    initAuditChart() {
      let roomChartEl = document.getElementById('audit-room-chart')
      let roomChart = this.$echarts.init(roomChartEl)

      let legendItemWH = {
        icon: 'circle',
        itemWidth: 10,
        itemHeight: 10
      }
      let legend = [
        {
          data: ['已通过'],
          x: '20%',
          y: '75%',
          ...legendItemWH
        },
        {
          data: ['审核中'],
          x: '55%',
          y: '75%',
          ...legendItemWH
        },
        {
          data: ['未通过'],
          x: '20%',
          y: '85%',
          ...legendItemWH
        },
        {
          data: ['已注销'],
          x: '55%',
          y: '85%',
          ...legendItemWH
        }
      ]

      let houseData = this.auditStat.dataHouseAudit || {}
      let roomChartOption = {
        color: ['#6ec132', '#4c90f0', '#5fdada', '#fca851'],
        title: {
          text: '房源',
          x: '38%',
          y: '30%',
          textStyle: {
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend,
        series: [
          {
            name: '房源',
            type: 'pie',
            radius: ['47%', '55%'],
            center: ['50%', '35%'],
            startAngle: 135,
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [
              { value: houseData.countAuditTure || 0, name: '已通过' },
              { value: houseData.countAuditWait || 0, name: '审核中' },
              { value: houseData.countAuditFalse || 0, name: '未通过' },
              { value: houseData.countCancel || 0, name: '已注销' }
            ]
          }
        ]
      }

      roomChart.setOption(roomChartOption, true)

      this.auditRoomChart = roomChart
      // this.setEchartsAni('auditRoomChart', 4) // 启用环形图动画

      let managerChartEl = document.getElementById('audit-manager-chart')
      let managerChart = this.$echarts.init(managerChartEl)

      let managerData = this.auditStat.dataOperatorAudit || {}
      let managerChartOption = {
        color: ['#eb7c7c', '#8a72d7', '#c2e37a', '#fcc451'],
        title: {
          text: '经营者',
          x: '33%',
          y: '30%',
          textStyle: {
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend,
        series: [
          {
            name: '经营者',
            type: 'pie',
            radius: ['47%', '55%'],
            center: ['50%', '35%'],
            startAngle: 135,
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [
              { value: managerData.countOptAuditTure || 0, name: '已通过' },
              { value: managerData.countOptAuditWait || 0, name: '审核中' },
              { value: managerData.countOptAuditFalse || 0, name: '未通过' },
              { value: managerData.countOptCancel || 0, name: '已注销' }
            ]
          }
        ]
      }

      managerChart.setOption(managerChartOption, true)
      this.auditManagerChart = managerChart
    },
    // 设置图表动画
    setEchartsAni(chartProp, dataLen) {
      let curIndex = 0
      clearInterval(this[chartProp + 'Timer'])

      this[chartProp + 'Timer'] = setInterval(() => {
        this[chartProp].dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: curIndex - 1 < 0 ? dataLen - 1 : curIndex - 1
        })
        this[chartProp].dispatchAction({
          type: 'hideTip'
        })
        this[chartProp].dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: curIndex
        })
        this[chartProp].dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: curIndex++
        })
        if (curIndex >= dataLen) {
          curIndex = 0
        }
      }, 3000)
    },
    // 初始化经营者统计图
    initManagerStatChart() {
      let chartEl = document.getElementById('manager-stat-chart')
      let chart = this.$echarts.init(chartEl)

      let managerStat = JSON.parse(JSON.stringify(this.managerStat))

      if (!this.enlargeManagerStat) {
        managerStat.sort((a, b) => b.countOperator - a.countOperator)
        if (managerStat.length > 10) {
          managerStat.length = 10
        }
      }

      let xAxisData = managerStat.map(item => item.countArea)
      let numList = managerStat.map(item => item.countOperator)
      let todayList = managerStat.map(item => item.countToday)
      let maxCount = Math.max(...numList)

      let option = {
        tooltip: {
          show: true,
          formatter: params => {
            return `${params[0].axisValueLabel}：${numList[params[0].dataIndex]}<br/>今日新增：${todayList[params[0].dataIndex]}`
          },
          trigger: 'axis'
        },
        grid: {
          top: '20px',
          left: '55px',
          right: '20px',
          bottom: '60px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { rotate: 30 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        series: [
          {
            // 阴影
            data: new Array(numList.length).fill(maxCount),
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderRadius: 5
            },
            barGap: '-100%',
            animation: false,
            silent: true
          },
          {
            // data: [120, 200, 150, 80, 70, 110, 130, 60, 30],
            data: numList,
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: '#68a9cb',
              borderRadius: 5
            }
          }
        ]
      }

      chart.setOption(option)
      this.managerStatChart = chart
    },
    // 初始化房源统计图
    initRoomStatChart() {
      let chartEl = document.getElementById('room-stat-chart')
      let chart = this.$echarts.init(chartEl)

      let houseStat = JSON.parse(JSON.stringify(this.houseStat))
      if (!this.enlargeHouseStat) {
        houseStat.sort((a, b) => b.countTotal - a.countTotal)
        if (houseStat.length > 10) {
          houseStat.length = 10
        }
      }

      let xAxisData = houseStat.map(item => item.countArea)
      let liveNumList = houseStat.map(item => item.countLive)
      let noLiveNumList = houseStat.map(item => item.countNoLive)
      let noLivePercentList = houseStat.map(item => item.noLivePercent)

      let totalCountList = houseStat.map(item => item.countTotal)
      let maxCount = Math.max(...totalCountList)

      let option = {
        legend: {
          show: true,
          data: ['入住数', '空置数', '空置率'],
          y: '0px',
          itemHeight: 10
        },
        tooltip: {
          show: true,
          formatter: params => {
            let textList = []
            params.forEach(item => {
              switch (item.seriesName) {
                case '空置率':
                  textList.push(`${item.seriesName}：${item.value}%`)
                  break
                case '空置数':
                case '入住数':
                  textList.push(`${item.seriesName}：${item.value}`)
                  break
              }
            })
            textList.push('总数：' + totalCountList[params[0].dataIndex])

            return `${params[0].axisValueLabel}<br />${textList.join('<br />')}`
          },
          trigger: 'axis'
        },
        grid: {
          top: '30px',
          left: '50px',
          right: '45px',
          bottom: '60px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { rotate: 30 }
        },
        yAxis: [
          {
            type: 'value',
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}%'
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '空置率',
            type: 'line',
            symbolSize: 1,
            smooth: true,
            yAxisIndex: 1,
            data: noLivePercentList,
            itemStyle: {
              color: 'rgb(215, 213, 213)'
            },
            lineStyle: {
              type: 'dashed',
              color: 'rgb(215, 213, 213)'
            },
            areaStyle: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          {
            // 阴影
            name: '阴影',
            data: new Array(totalCountList.length).fill(maxCount),
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderRadius: 5
            },
            barGap: '-100%',
            animation: false,
            silent: true
          },
          {
            name: '入住数',
            data: liveNumList,
            type: 'bar',
            stack: '总数',
            barWidth: 10,
            itemStyle: {
              color: '#68a9cb',
              borderRadius: [0, 0, 5, 5]
            }
          },
          {
            name: '空置数',
            data: noLiveNumList,
            type: 'bar',
            stack: '总数',
            barWidth: 10,
            itemStyle: {
              color: '#f09e54',
              borderRadius: [5, 5, 0, 0]
            }
          }
        ]
      }

      chart.setOption(option)
      this.roomStatChart = chart
    }
  }
}
